// temp key
import { Configuration, OpenAIApi } from "openai";

const configuration = new Configuration({
    apiKey: "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",
});

const openai = new OpenAIApi(configuration);

function generatePrompt(question) {
    const _prompt = question[0].toUpperCase() + question.slice(1).toLowerCase();
    // add something related with patient navigation We are talking about patient navigation. I have a question, it is:
    return `${_prompt}`;
}

const roleDrDescrp = `You are Dr Haiel, a patient navigator medical assistant. You give medical suggestions.\nYour CAPABILITY AND ROLE: Healthcare Navigator.\nGENERAL RULES: \n1. If user mention something related to patient navigating, Dr Haiel should answer based on the actions.\n2. Data Presentation Format: It is crucial to always present any data obtained in a tabular format. This format aids in clarity and ease of reading for the user.\n3. Any value of parameter you input in action should match a term in your knowledge base. Never input a value without checking knowledge base!\n4. Emergency Situations Protocol: In cases of medical emergencies, like a heart attack, emphasize the importance of immediate medical attention.  Advise users to contact emergency services or visit the nearest emergency room while you assist in finding a physician.\n5. User Interaction and Feedback Incorporation: Engage with the user to clarify their needs and incorporate their feedback for continuous improvement.  This ensures that each interaction is tailored to the user's specific requirements.\n6. Regular Reminders and Checks: Before each action related to the task, remind yourself of instructions.  Regularly check your responses against these instructions to ensure adherence.\n7. If user haven't provided you with needed information, ask again, do not presume a value of parameter and start action.\n` +
    `Do not show table in the response.`;

const generateMoreQuestions = async (contentText) => {
    const result = {};

    if (!configuration.apiKey) {
        result.error.message = "OpenAI API key not configured";
        return result;
    }

    const question = contentText || "";

    if (question.trim().length === 0) {
        result.error.message = "Please enter a valid question";
        return result;
    }

    try {
        const completion = await openai.createChatCompletion({
            model: "gpt-3.5-turbo",
            messages: [
                { role: "user", content: "Please generate 3 further questions for me to ask from the text, put them in a json string array like [\"quesiotn1\", \"questions2\", \"question3\"]:\n\n" + contentText },
                { role: "assistant", content: "Here is the json string array:" },
            ],
        });

        result.data = { result: completion.data.choices[0].message.content };
    } catch (error) {
        // Consider adjusting the error handling logic for your use case
        if (error.response) {
            console.error(error.response.status, error.response.data);
            // res.status(error.response.status).json(error.response.data);
            result.error.message = error.response.data;
        } else {
            console.error(`Error with OpenAI API request: ${error.message}`);
            result.error.message = "An error occurred during your request.";
        }
    }
    return result;
}

const getDKWinResponse = async (contentText) => {
    const result = {};

    if (!configuration.apiKey) {
        result.error.message = "OpenAI API key not configured";
        return result;
    }

    const question = contentText || "";

    if (question.trim().length === 0) {
        result.error.message = "Please enter a valid question";
        return result;
    }

    try {
        const completion = await openai.createChatCompletion({
            model: "gpt-3.5-turbo",
            messages: [
                { role: "user", content: "Please find disease word in the text, put them in a json string array like [\"disease1\", \"disease2\", \"disease3\"]:\n\n" + contentText },
                { role: "assistant", content: "Here is the json string array:" },
            ],
        });

        result.data = { result: completion.data.choices[0].message.content };
    } catch (error) {
        // Consider adjusting the error handling logic for your use case
        if (error.response) {
            console.error(error.response.status, error.response.data);
            // res.status(error.response.status).json(error.response.data);
            result.error.message = error.response.data;
        } else {
            console.error(`Error with OpenAI API request: ${error.message}`);
            result.error.message = "An error occurred during your request.";
        }
    }
    return result;
}


const generateAnswer = async (questionInput) => {
    const result = {};

    if (!configuration.apiKey) {
        result.error.message = "OpenAI API key not configured";
        return result;
    }

    const question = questionInput || "";

    if (question.trim().length === 0) {
        result.error.message = "Please enter a valid question";
        return result;
    }

    try {
        const completion = await openai.createChatCompletion({
            model: "gpt-4",
            messages: [
                {
                    role: "system",
                    content: roleDrDescrp,
                },
                { role: "user", content: question },
            ],
        });

        // const completion = await openai.createCompletion({
        //   model: "text-davinci-003",
        //   prompt: generatePrompt(question),
        //   max_tokens: 1000,
        //   temperature: 0.6,
        // });

        // console.log("try prompt end: ", completion);
        result.data = { result: completion.data.choices[0].message.content };
    } catch (error) {
        // Consider adjusting the error handling logic for your use case
        if (error.response) {
            console.error(error.response.status, error.response.data);
            // res.status(error.response.status).json(error.response.data);
            result.error.message = error.response.data;
        } else {
            console.error(`Error with OpenAI API request: ${error.message}`);
            result.error.message = "An error occurred during your request.";
        }
    }
    return result;
};

export { generateAnswer, generateMoreQuestions, getDKWinResponse }


// WEBPACK FOOTER //
// ./src/api/chatgpt.js